import { render, staticRenderFns } from "./trendsDetail.vue?vue&type=template&id=03d81887&scoped=true"
import script from "./trendsDetail.vue?vue&type=script&lang=js"
export * from "./trendsDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetailNew.css?vue&type=style&index=0&id=03d81887&prod&scoped=true&lang=css&external"
import style1 from "./trendsDetail.vue?vue&type=style&index=1&id=03d81887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d81887",
  null
  
)

export default component.exports